// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import SubscriptionFormController from "./subscription_form_controller"
application.register("subscription-form", SubscriptionFormController)

import AdminFiltersController from "./admin_filters_controller"
application.register("admin-filters", AdminFiltersController)

import EmailProtectionController from "./email_protection_controller"
application.register("email-protection", EmailProtectionController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import DeliveryChartController from "./delivery_chart_controller"
application.register("delivery-chart", DeliveryChartController)

import NestedSectionsController from "./nested_sections_controller"
application.register("nested-sections", NestedSectionsController)

import AlternativeSubjectsController from "./alternative_subjects_controller"
application.register("alternative-subjects", AlternativeSubjectsController)

import BotProtectionController from "./bot_protection_controller"
application.register("bot-protection", BotProtectionController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import BlackoutFormController from "./blackout_form_controller"
application.register("blackout-form", BlackoutFormController)
